__turbopack_context__.v({
  "bullets": "ntG1xa_bullets",
  "image": "ntG1xa_image",
  "slideInAnimation": "ntG1xa_slideInAnimation",
});
